<template>
  <div class="main-content">
    <md-whiteframe
      md-elevation="0"
      class="camera-toolbar"
    >
      <md-toolbar class="md-dense">
        <md-button
          class="md-icon-button"
          @click="$router.go(-1)"
        >
          <md-icon>arrow_back</md-icon>
        </md-button>
        <h2
          class="md-title"
          style="flex:1"
        >
          <b>{{activeItem.name}}</b>
        </h2>
        <span class="equipment-description">{{activeItem.description}}</span>
      </md-toolbar>
    </md-whiteframe>
    <md-layout md-column>
      <span class="md-subheading photo-title">Fotografe os focos solicitados abaixo</span>
      <md-stepper
        md-vertical
        md-alternate-labels
        @completed="onCompleted"
      >
        <md-step
          :md-active="key <= 0"
          v-for="(photo, key) in activeItem.photos"
          :key="photo['.key']"
          :photoId="key"
          :md-label="photo.name"
          :md-continue="photo.image!=='' && photo.image !== null && photo.image !== undefined"
          :md-message="photo.description"
          :md-button-continue="continueButton"
          md-button-back="ANTERIOR"
          :md-editable="true"
        >
          <camera-image-select
            ref="cameraImageSelect"
            :photoId="key"
            :description="photo.description"
            :imageId="photo.image"
            :imageUrl="photo.url"
            v-on:add="addPhoto"
            v-on:select="previewImage"
          ></camera-image-select>
        </md-step>
      </md-stepper>
    </md-layout>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import CameraImageSelect from '@/components/CameraImageSelect'
export default {
  name: 'camera',
  components: {
    CameraImageSelect
  },
  computed: {
    ...mapState({
      certificationProcess: state => state.certificationProcess
    })
  },
  data: () => ({
    previewSrc: '',
    activeImgId: null,
    activePhotoKey: 0,
    imgW: 0,
    imgH: 0,
    activeArea: 0,
    activeType: '',
    activeStructureKey: 0,
    activeItem: {},
    continueButton: 'PRÓXIMO',
    isFinished: false
  }),
  beforeMount () {
    this.activeArea = this.$route.params.area
    this.activeType = this.$route.params.type
    this.activeStructureKey = this.$route.params.structureKey
    this.FETCH_DATA().then(() => {
      this.loadItem()
    })
  },
  methods: {
    ...mapActions(['FETCH_DATA', 'FETCH_IMAGE', 'SET_PHOTO']),
    openDialog (ref) {
      this.$refs[ref].open()
      this.isFinished = false
    },
    closeDialog (ref) {
      this.isFinished = false
      this.$refs[ref].close()
    },
    loadItem () {
      if (this.activeType === 'vertice') {
        this.activeItem = this.certificationProcess.areas[this.activeArea].vertices[this.activeStructureKey]
      } else {
        this.activeItem = this.certificationProcess.areas[this.activeArea].structures[this.activeStructureKey]
      }
      if (this.activeItem.photos[0].image) {
        this.activeImgId = this.activeItem.photos[0].image
        this.activePhotoKey = 0
        // this.loadImage()
      }
    },
    removePhoto () {
      this.$refs.cameraImageSelect[this.activePhotoKey].remove()
      this.previewSrc = ''
      this.activePhotoKey = 0
    },
    revokeURL () {
      URL.revokeObjectURL(this.previewSrc)
    },
    loadImage () {
      console.log('loading image')
      var vm = this
      this.FETCH_IMAGE(this.activeImgId).then(imageBlob => {
        URL.revokeObjectURL(vm.previewSrc)
        vm.previewSrc = URL.createObjectURL(imageBlob)
      }).catch(() => {
        console.log('imagem não existe localmente')
        console.log(vm.activeItem.photos[vm.activePhotoKey].url)
        vm.previewSrc = vm.activeItem.photos[vm.activePhotoKey].url
      })
    },
    addPhoto (imgId, photoKey, preview) {
      var vm = this
      vm.activeImgId = imgId
      vm.activePhotoKey = photoKey
      this.SET_PHOTO({
        areaKey: this.activeArea,
        type: this.activeType,
        structureKey: this.activeStructureKey,
        photoKey: this.activePhotoKey,
        image: this.activeImgId
      }).then(() => {
        vm.previewSrc = preview
        vm.checkFinished()
      })
    },
    checkFinished () {
      var hasFinished = true
      this.activeItem.photos.forEach(photo => {
        if (!photo.image) { hasFinished = false }
      })

      this.isFinished = hasFinished

      if (hasFinished) {
        this.continueButton = 'FINALIZAR'
      }
    },
    onCompleted () {
      if (this.isFinished) {
        this.$router.go(-1)
      }
    },
    previewImage (imageId, photoKey) {
      console.log('previewImage')
      this.activeImgId = imageId
      this.activePhotoKey = photoKey
      this.loadImage()
    }
  }
}
</script>
<style scoped>
.main-content {
  background-color: black;
  color: white;
  padding-top: 60px;
}

.photo-title {
  margin: 10px;
}

.camera-toolbar {
  position: absolute;
  width: 100%;
  top: 0px;
  z-index: 10;
}

.camera-botton-bar {
  position: absolute;
  bottom: 2px;
  width: 100%;
  z-index: 999999999;
}

.required-photos {
  margin: 18px;
}

.camera-toolbar > .md-toolbar {
  background-color: black;
  color: white;
}
.croppa-container {
  background-color: orange;
  border: 2px solid grey;
  border-radius: 8px;
}

.croppa-container:hover {
  opacity: 1;
  background-color: orange;
}

.equipment-description {
  max-height: 20px;
  font-size: 12px;
  overflow: hidden;
}
</style>




// WEBPACK FOOTER //
// CameraView.vue?091a6df0